import React from 'react'
import { UseFormRegister, FieldErrors } from 'react-hook-form'
import { OAuthUser } from '../../../../site/pbTypes'
import { formatPhoneNumber } from '../../../../utils'
import { StorageFormValues } from '../config/validationSchema'

interface PersonalInfoStepProps {
  register: UseFormRegister<StorageFormValues>
  errors: FieldErrors<StorageFormValues>
  oauthUser?: OAuthUser
  isAuthenticated?: boolean
  onLoginClick?: () => void
}

const PersonalInfoStep: React.FC<PersonalInfoStepProps> = ({
  register,
  errors,
  oauthUser,
  isAuthenticated = false,
  onLoginClick
}) => {
  return (
    <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
      {!isAuthenticated && onLoginClick && (
        <div style={{
          backgroundColor: '#f0f7ff',
          border: '2px solid #232043',
          borderRadius: '8px',
          padding: '1rem 1.5rem',
          marginBottom: '2rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ color: '#232043' }}>
            <strong>Already a customer?</strong> Log in to skip steps and reserve faster.
          </div>
          <button
            type="button"
            onClick={onLoginClick}
            style={{
              background: '#232043',
              color: 'yellow',
              border: 'none',
              padding: '0.5rem 1.5rem',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 700,
              letterSpacing: 1.2,
              fontSize: '0.9rem',
              whiteSpace: 'nowrap'
            }}
          >
            Log In
          </button>
        </div>
      )}

      <div style={{ marginBottom: '1.5rem' }}>
        <label htmlFor="first_name" className="forceBlack">First Name</label>
        <input
          required
          id="first_name"
          placeholder="Enter your first name"
          type="text"
          {...register('first_name')}
          className={errors.first_name ? 'text-input is-required error' : 'text-input'}
        />
        {errors.first_name && <div className="input-feedback">{errors.first_name.message}</div>}
      </div>

      <div style={{ marginBottom: '1.5rem' }}>
        <label htmlFor="last_name" className="forceBlack">Last Name</label>
        <input
          required
          id="last_name"
          placeholder="Enter your last name"
          type="text"
          {...register('last_name')}
          className={errors.last_name ? 'text-input error' : 'text-input'}
        />
        {errors.last_name && <div className="input-feedback">{errors.last_name.message}</div>}
      </div>

      {!oauthUser ? (
        <div style={{ marginBottom: '1.5rem' }}>
          <label htmlFor="email" className="form-label forceBlack">Email</label>
          <input
            aria-label="email"
            id="email"
            type="email"
            required
            placeholder="Enter your email"
            {...register('email')}
            className={errors.email ? 'text-input error' : 'text-input'}
          />
          {errors.email && <div className="input-feedback">{errors.email.message}</div>}
        </div>
      ) : (
        <div style={{ marginBottom: '1.5rem' }}>
          <label className="form-label forceBlack">Email</label>
          <div className="is-size-6 forceBlack" style={{ display: "flex", flexDirection: "row", gap: 8, flexWrap: 'wrap', marginTop: '0.5rem' }}>
            <img
              style={{ width: 30, height: 30 }}
              src={new URL(`../../../../site/images/Google_Authed_G.png`, import.meta.url).href}
              alt="Continue with Google"
            />
            <strong>{oauthUser?.rawUser.email}</strong>
          </div>
        </div>
      )}

      <div style={{ marginBottom: '1.5rem' }}>
        <label htmlFor="phone" className="forceBlack">Phone</label>
        <input
          required
          id="phone"
          placeholder="Enter your phone"
          type="text"
          maxLength={14}
          {...register('phone', {
            onChange: (e) => {
              e.target.value = formatPhoneNumber(e.target.value)
            }
          })}
          className={errors.phone ? 'text-input error' : 'text-input'}
        />
        {errors.phone && <div className="input-feedback">{errors.phone.message}</div>}
      </div>

      <div style={{ marginBottom: '1.5rem' }}>
        <label htmlFor="other_phone" className="forceBlack">
          Other Phone <span style={{ fontSize: 14 }}>(optional)</span>
        </label>
        <input
          id="other_phone"
          placeholder="Other phone"
          type="text"
          {...register('other_phone')}
          className="text-input"
        />
      </div>
    </div>
  )
}

export default PersonalInfoStep
